__turbopack_context__.v({
  "clone": "Marquee-module-scss-module__raKy6W__clone",
  "content": "Marquee-module-scss-module__raKy6W__content",
  "contentGroup": "Marquee-module-scss-module__raKy6W__contentGroup",
  "marquee": "Marquee-module-scss-module__raKy6W__marquee",
  "pausable": "Marquee-module-scss-module__raKy6W__pausable",
  "reverse": "Marquee-module-scss-module__raKy6W__reverse",
  "scroll": "Marquee-module-scss-module__raKy6W__scroll",
});
